var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    fillOpacity: 0.01
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.7662 3.98276C13.0092 4.08343 13.2299 4.23099 13.4159 4.41701L19.5839 10.584C19.77 10.7699 19.9177 10.9907 20.0185 11.2338C20.1192 11.4769 20.1711 11.7374 20.1711 12.0005C20.1711 12.2636 20.1192 12.5242 20.0185 12.7672C19.9177 13.0103 19.77 13.2311 19.5839 13.417L13.4159 19.584C13.2299 19.77 13.0092 19.9176 12.7662 20.0183C12.5233 20.1189 12.2629 20.1707 11.9999 20.1707C11.7369 20.1707 11.4764 20.1189 11.2335 20.0183C10.9905 19.9176 10.7698 19.77 10.5839 19.584L4.41586 13.417C4.22969 13.2311 4.08201 13.0103 3.98124 12.7672C3.88048 12.5242 3.82861 12.2636 3.82861 12.0005C3.82861 11.7374 3.88048 11.4769 3.98124 11.2338C4.08201 10.9907 4.22969 10.7699 4.41586 10.584L10.5839 4.41701C10.7698 4.23099 10.9905 4.08343 11.2335 3.98276C11.4764 3.88208 11.7369 3.83026 11.9999 3.83026C12.2629 3.83026 12.5233 3.88208 12.7662 3.98276ZM11.2927 13.7071C11.4803 13.8946 11.7346 14 11.9999 14C12.2651 14 12.5194 13.8946 12.707 13.7071C12.8945 13.5196 12.9999 13.2652 12.9999 13V8C12.9999 7.73478 12.8945 7.48043 12.707 7.29289C12.5194 7.10536 12.2651 7 11.9999 7C11.7346 7 11.4803 7.10536 11.2927 7.29289C11.1052 7.48043 10.9999 7.73478 10.9999 8V13C10.9999 13.2652 11.1052 13.5196 11.2927 13.7071ZM11.2927 16.7071C11.4803 16.8946 11.7346 17 11.9999 17C12.2651 17 12.5194 16.8946 12.707 16.7071C12.8945 16.5196 12.9999 16.2652 12.9999 16C12.9999 15.7348 12.8945 15.4804 12.707 15.2929C12.5194 15.1054 12.2651 15 11.9999 15C11.7346 15 11.4803 15.1054 11.2927 15.2929C11.1052 15.4804 10.9999 15.7348 10.9999 16C10.9999 16.2652 11.1052 16.5196 11.2927 16.7071Z",
    fill: "#D13D3E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/error.58a5039ca3243481f78705b3d457b65c.svg";
export { ForwardRef as ReactComponent };